// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_SetupDeviceInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/devices_franquias/setup_device
 *
 * Sets up a WhatsApp device in Evolution API and returns QR code for pairing.
 */
import { registerContract } from './validate'

export interface DevicesFranquias_SetupDeviceInput {
device_id: number
instance_name: string
}

registerContract('DevicesFranquias_SetupDeviceInput', {
  device_id:     { type: 'number',  required: true },
  instance_name: { type: 'string',  required: true },
})
